module.exports = __webpack_public_path__ + "static/media/birth-cert-reminder-icon.403807e0.png";